import { ReactNode, useRef } from "react"; // <-- useRef importálása

interface DateFieldProps {
  name: string;
  value?: string;
  icon?: ReactNode;
  disabled?: boolean;
  hasError?: boolean;
  onChange?: (value: string) => void;
}

const DateField: React.FunctionComponent<DateFieldProps> = ({
  name,
  value,
  icon,
  disabled,
  hasError,
  onChange,
}) => {
  // 1. Létrehozunk egy 'ref'-et, amivel elérjük a DOM input elemet
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  // 2. Ezt a függvényt hívjuk meg, ha a komponens területére kattintanak
  const handleContainerClick = () => {
    // Ha az input nem disabled, programozottan megnyitjuk a naptárat
    if (!disabled && inputRef.current?.showPicker) {
      inputRef.current.showPicker();
    }
  };

  return (
    // 3. Az onClick eseményt a külső `div`-re tesszük
    <div className="relative" onClick={handleContainerClick}>
      {icon && (
        <div className={"input-icon" + (disabled ? " disabled" : "") + (hasError ? " error" : "")}>
          {/* A saját ikonunkra kattintás is a handleContainerClick-et fogja aktiválni */}
          {icon}
        </div>
      )}

      <input
        // 4. Hozzárendeljük a 'ref'-et az inputhoz
        ref={inputRef}
        type="date"
        name={name}
        disabled={disabled}
        className={"input-field" + (hasError ? " error" : "")}
        value={value}
        onChange={handleChange}
        // Az inputról levesszük az onClick-et, mert a szülő div kezeli
      />
    </div>
  );
};

export default DateField;